export function getFormOrigin(
  url: string | undefined,
  locationOnPage: string | undefined,
): string | undefined {
  if (!url) return undefined;

  const { origin, pathname, hash } = new URL(url);

  if (hash) {
    console.warn(`hash value ${hash} present, overriding`);
  }

  if (locationOnPage) {
    return `${origin}${pathname}#${locationOnPage}`;
  }

  return `${origin}${pathname}`;
}
